export function common(){
    const header = document.getElementById('site-header');
    if(header){
        header.classList.add('active');
    }
}